<nav
  class="mobile-bottom-nav"
  aria-label="Primary mobile navigation"
  fxLayout="row"
  fxLayoutAlign="space-around stretch"
>
  @for (item of primaryItems; track item.routerLink) {
    <a
      mat-button
      fxFlex
      class="mobile-bottom-nav__item"
      [routerLink]="menuService.getRouterLink(item)"
      routerLinkActive="mobile-bottom-nav__item--active"
      [routerLinkActiveOptions]="{ exact: item.exactRouteMatch !== false }"
      (click)="menuService.handleMenuClick(item)"
    >
      <span
        class="mobile-bottom-nav__content"
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="2px"
      >
        @if (item.badge === 'chat') {
          <mat-icon
            class="mobile-bottom-nav__icon mobile-bottom-nav__badge mobile-bottom-nav__badge--dot"
            matBadge="&#8226;"
            matBadgePosition="above after"
            matBadgeSize="small"
            [matBadgeHidden]="!(unreadMessages$ | async)"
          >
            {{ item.icon }}
          </mat-icon>
        } @else if (item.badge === 'activities') {
          <mat-icon
            class="mobile-bottom-nav__icon mobile-bottom-nav__badge mobile-bottom-nav__badge--dot"
            matBadge="&#8226;"
            matBadgePosition="above after"
            matBadgeSize="small"
            [matBadgeHidden]="!(activitiesNavBadge$ | async)"
          >
            {{ item.icon }}
          </mat-icon>
        } @else if (item.badge === 'survey') {
          <mat-icon
            class="mobile-bottom-nav__icon mobile-bottom-nav__badge mobile-bottom-nav__badge--dot"
            matBadge="&#8226;"
            matBadgePosition="above after"
            matBadgeSize="small"
            [matBadgeHidden]="!(requestedSurveysBadge$ | async)"
          >
            {{ item.icon }}
          </mat-icon>
        } @else {
          <mat-icon class="mobile-bottom-nav__icon">{{ item.icon }}</mat-icon>
        }
        <span class="mobile-bottom-nav__label">{{ item.title }}</span>
      </span>
    </a>
  }

  @if (overflowItems.length > 0 || showFieldManagementReporting) {
    <button
      mat-button
      type="button"
      fxFlex
      class="mobile-bottom-nav__item"
      [class.mobile-bottom-nav__item--active]="isOverflowActive"
      [matMenuTriggerFor]="moreMenu"
    >
      <span
        class="mobile-bottom-nav__content"
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="2px"
      >
        <mat-icon
          class="mobile-bottom-nav__icon mobile-bottom-nav__more-badge"
          matBadge="&#8226;"
          matBadgePosition="above after"
          matBadgeSize="small"
          [matBadgeHidden]="!showMoreBadge"
        >
          more_horiz
        </mat-icon>
        <span class="mobile-bottom-nav__label">More</span>
      </span>
    </button>
  }
</nav>

<mat-menu #moreMenu="matMenu" xPosition="before" class="mobile-more-menu">
  @for (item of overflowItems; track item.routerLink) {
    <a mat-menu-item [routerLink]="menuService.getRouterLink(item)" (click)="onOverflowItemClick(item)">
      @if (item.badge === 'chat') {
        <mat-icon
          class="mobile-more-menu__badge mobile-more-menu__badge--dot"
          matBadge="&#8226;"
          matBadgePosition="above after"
          matBadgeSize="small"
          [matBadgeHidden]="!(unreadMessages$ | async)"
        >
          {{ item.icon }}
        </mat-icon>
      } @else if (item.badge === 'activities') {
        <mat-icon
          class="mobile-more-menu__badge mobile-more-menu__badge--dot"
          matBadge="&#8226;"
          matBadgePosition="above after"
          matBadgeSize="small"
          [matBadgeHidden]="!(activitiesNavBadge$ | async)"
        >
          {{ item.icon }}
        </mat-icon>
      } @else if (item.badge === 'survey') {
        <mat-icon
          class="mobile-more-menu__badge mobile-more-menu__badge--dot"
          matBadge="&#8226;"
          matBadgePosition="above after"
          matBadgeSize="small"
          [matBadgeHidden]="!(requestedSurveysBadge$ | async)"
        >
          {{ item.icon }}
        </mat-icon>
      } @else if (item.icon) {
        <mat-icon>{{ item.icon }}</mat-icon>
      } @else if (item.svgIcon) {
        <mat-icon [svgIcon]="item.svgIcon"></mat-icon>
      }
      <span>{{ item.title }}</span>
    </a>
  }

  @if (showFieldManagementReporting) {
    <button mat-menu-item type="button" (click)="goToPowerBI()">
      <mat-icon>analytics</mat-icon>
      <span>FM Reporting</span>
    </button>
  }
</mat-menu>
